export default __webpack_public_path__ + "static/media/Robot.b686b973.svg";